export default __webpack_public_path__ + "static/media/me_back_mobile.f95957c5.png";